import { editAccountInfo } from '@/api/account';
import Button from '@/components/Button';
import Dialog from '@/components/Dialog';
import DatePicker from '@/components/Form/DatePicker';
import DatePickerProvider from '@/components/Form/DatePicker/DatePickerProvider';
import MobileDatePicker from '@/components/Form/MobileDatePicker';
import Image from '@/components/Image';
import WapOnly from '@/components/Responsive/WapOnly';
import WebOnly from '@/components/Responsive/WebOnly';
import { toast } from '@/components/Toast';
import { useStore } from '@/providers/app-store-provider';
import logger from '@/utils/client-logger';
import { env } from '@/utils/env';
import dayjs from 'dayjs';
import { useTranslations } from 'next-intl';
import { useEffect, useState } from 'react';

export default function RewardItems({
  memberLevelConfig,
  memberPrivileges,
  SDRewardsPageBtnClick,
}: {
  memberLevelConfig: any;
  memberPrivileges: any;
  SDRewardsPageBtnClick: (btnName: string) => void;
}) {
  logger.log(memberLevelConfig, memberPrivileges);
  const t = useTranslations('zeeloolRewards.rewardItems');
  const userInfo = useStore((state) => state.userInfo);
  const [memberLevelPrivilegesItem, setMemberLevelPrivilegesItem] = useState({});
  const [levelConfig, setLevelConfig] = useState({
    bgcolor: '',
    bgIcon: '',
  });
  const refreshAccountInfo = useStore((state) => state.refreshAccountInfo);
  const [showBirthdayPicker, setShowBirthdayPicker] = useState(false);
  const [showBirthdayConfirm, setShowBirthdayConfirm] = useState(false);
  const [birthday, setBirthday] = useState<string | null>(null);
  const [isChangeBirthday, setIsChangeBirthday] = useState(userInfo.is_change_birthday === 1);
  const [showWebBirthdayDialog, setShowWebBirthdayDialog] = useState(false);
  const [webBirthday, setWebBirthday] = useState<dayjs.Dayjs | null>(null);

  useEffect(() => {
    const member_level_privileges_item =
      memberPrivileges.member_level_privileges[userInfo.member_level || 0];
    setMemberLevelPrivilegesItem(member_level_privileges_item);
    setLevelConfig(memberLevelConfig[`v${userInfo.member_level || 0}`]);
    setIsChangeBirthday(userInfo.is_change_birthday === 1);
  }, [userInfo.member_level, memberPrivileges]);

  const getEquityStatement = (key: string) => {
    return memberPrivileges.equity_statement.find((item: any) => item.id === key)?.name || '-';
  };

  const handleOpenBirthdayPicker = () => {
    SDRewardsPageBtnClick('Fill In');
    if (isChangeBirthday) {
      if (typeof window !== 'undefined' && window.innerWidth > 768) {
        setShowWebBirthdayDialog(true);
      } else {
        setShowBirthdayPicker(true);
      }
    }
  };

  const handleCancelBirthday = () => {
    setShowBirthdayPicker(false);
  };

  const handleBirthdaySave = (date: Date | dayjs.Dayjs | null) => {
    if (!date) return;
    const formattedDate = dayjs(date).format('YYYY-MM-DD');
    setBirthday(formattedDate);
    setShowBirthdayConfirm(true);
  };

  const handleWebBirthdaySave = () => {
    if (!webBirthday) return;
    setBirthday(webBirthday.format('YYYY-MM-DD'));
    setShowWebBirthdayDialog(false);
    setShowBirthdayConfirm(true);
  };

  const saveBirthday = async () => {
    if (!birthday) return;
    const response = await editAccountInfo({
      change: 2,
      birthday,
    });
    if (response?.code === 200) {
      toast.success(response.msg);
      refreshAccountInfo();
    }
    setShowBirthdayConfirm(false);
    setShowBirthdayPicker(false);
  };

  return (
    <>
      <WebOnly>
        <div className="w-full grid w-fit grid-cols-3 gap-16">
          {(() => {
            const items = Object.keys(memberLevelPrivilegesItem).filter(
              (item) => memberLevelPrivilegesItem[item],
            );

            // 如果生日为空且存在birthday_pack，将其移到第一位
            const birthdayPackIndex = items.indexOf('birthday_pack');
            if (!userInfo.birthday && birthdayPackIndex !== -1) {
              // 移除birthday_pack从原位置
              items.splice(birthdayPackIndex, 1);
              // 添加到第一位
              items.unshift('birthday_pack');
            }

            return items.map((item) => {
              // 生日为空时的birthday_pack特殊处理
              const isBirthdayEmpty = !userInfo.birthday && item === 'birthday_pack';

              return (
                <div
                  className=" h-[80px] bg-[#f4f4f4] rounded-[8px] flex items-center justify-start gap-16 pl-20 pr-[15px] py-16"
                  key={item}
                >
                  <div
                    className={`flex items-center justify-center w-[48px] h-[48px] rounded-full relative ${
                      isBirthdayEmpty ? 'bg-[#D4D4D4]' : levelConfig?.bgcolor
                    }`}
                  >
                    {isBirthdayEmpty && (
                      <Image
                        src="/account/zeelool-rewards/lock-02.png"
                        alt="lock"
                        width={16}
                        height={16}
                        className="absolute top-[0] right-[0] w-[16px] h-[16px]"
                      />
                    )}
                    <Image
                      src={memberLevelConfig.icon[item]}
                      alt="zeelool icon"
                      width={26}
                      height={26}
                      className={`${isBirthdayEmpty ? 'opacity-40' : ''}`}
                    />
                  </div>
                  <span className="text-16 font-br text-left flex-1">
                    {getEquityStatement(item)}
                  </span>
                  {!userInfo.birthday && item === 'birthday_pack' && (
                    <>
                      <Button
                        variant="contained"
                        radiusSize="large"
                        className="text-14 !font-bb !ml-auto !min-w-[87px] !h-[32px] !rounded-[24px]"
                        onClick={handleOpenBirthdayPicker}
                      >
                        {t('fillIn')}
                      </Button>
                    </>
                  )}
                </div>
              );
            });
          })()}
          {/* PC端生日选择弹窗 */}
          <DatePickerProvider>
            <Dialog
              showCloseIcon
              open={showWebBirthdayDialog}
              onOk={handleWebBirthdaySave}
              onClose={() => setShowWebBirthdayDialog(false)}
              okText={t('confirm')}
            >
              <DatePicker
                value={webBirthday}
                onChange={setWebBirthday}
                placeholder={t('birthday')}
                maxDate={dayjs()}
                minDate={dayjs().subtract(100, 'year')}
                format={env.NEXT_PUBLIC_DATE_FORMAT}
              />
            </Dialog>
          </DatePickerProvider>
          {/* PC端生日确认弹窗 */}
          <Dialog
            showCloseIcon={false}
            open={showBirthdayConfirm}
            onOk={saveBirthday}
            onClose={() => {
              setBirthday(null);
              setShowBirthdayConfirm(false);
            }}
            okText={t('confirm')}
          >
            <div className="mb-4">{t('birthdayConfirmMessage', { birthday })}</div>
          </Dialog>
        </div>
      </WebOnly>
      <WapOnly>
        <div className="px-14 grid w-fit grid-cols-2 gap-8">
          {(() => {
            const items = Object.keys(memberLevelPrivilegesItem).filter(
              (item) => memberLevelPrivilegesItem[item],
            );

            // 如果生日为空且存在birthday_pack，将其移到第一位
            const birthdayPackIndex = items.indexOf('birthday_pack');
            if (!userInfo.birthday && birthdayPackIndex !== -1) {
              // 移除birthday_pack从原位置
              items.splice(birthdayPackIndex, 1);
              // 添加到第一位
              items.unshift('birthday_pack');
            }

            return items.map((item) => {
              // 生日为空时的birthday_pack占满整行
              const isBirthdayEmpty = !userInfo.birthday && item === 'birthday_pack';

              return (
                <div
                  className={`h-[66px] bg-[#f4f4f4] rounded-[8px] flex items-center justify-start gap-8 px-8 ${
                    isBirthdayEmpty ? 'col-span-2 pl-10 pr-[13px]' : ''
                  }`}
                  key={item}
                >
                  <div
                    className={`flex items-center justify-center w-[40px] h-[40px] min-w-[40px] min-h-[40px] rounded-full relative ${
                      isBirthdayEmpty ? 'bg-[#D4D4D4]' : levelConfig?.bgcolor
                    }`}
                  >
                    {isBirthdayEmpty && (
                      <Image
                        src="/account/zeelool-rewards/lock-02.png"
                        alt="lock"
                        width={16}
                        height={16}
                        className="absolute top-[0] right-[0] w-[15px] h-[15px]"
                      />
                    )}
                    <Image
                      src={memberLevelConfig.icon[item]}
                      alt="zeelool icon"
                      width={22}
                      height={22}
                      className={`${isBirthdayEmpty ? 'opacity-40' : ''}`}
                    />
                  </div>

                  <span className="text-[13px] font-br text-left leading-[16px]">
                    {getEquityStatement(item)}
                  </span>
                  {!userInfo.birthday && item === 'birthday_pack' && (
                    <div className="ml-auto">
                      <Button
                        variant="contained"
                        radiusSize="large"
                        className="text-12 !font-bs !ml-auto !min-w-[55px] !h-[24px] !rounded-[12px]"
                        onClick={handleOpenBirthdayPicker}
                      >
                        {t('fillIn')}
                      </Button>
                    </div>
                  )}
                </div>
              );
            });
          })()}
          {/* 移动端生日选择弹窗和确认弹窗 */}
          <MobileDatePicker
            open={showBirthdayPicker}
            title={t('birthday')}
            order="MDY"
            value={birthday ? new Date(birthday) : new Date('2000-01-01')}
            onSave={handleBirthdaySave}
            onCancel={handleCancelBirthday}
            onClose={() => setShowBirthdayPicker(false)}
            cancelText={t('cancel')}
            saveText={t('save')}
            dateRange={{
              minDate: new Date(new Date().getFullYear() - 100, 0, 1),
              maxDate: new Date(),
            }}
          />
          <Dialog
            showCloseIcon={false}
            open={showBirthdayConfirm}
            onOk={saveBirthday}
            onClose={() => {
              setBirthday(null);
              setShowBirthdayConfirm(false);
            }}
            okText={t('confirm')}
          >
            <div className="mb-4">{t('birthdayConfirmMessage', { birthday })}</div>
          </Dialog>
        </div>
      </WapOnly>
    </>
  );
}
